import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter, Link} from 'react-router-dom';
import "./ExploreBtn.css";

class ExploreBtn extends Component {

  render() {
    const {link} = this.props;
    if(!link){
      return '';
    }
    return (
      <div className="fow-explore-btn">
        <Link to={`?page=${link}`} className="fow-font-text fow-font-size-md">
          <span>Explore this topic in detail</span>
        </Link>
      </div>
    );
  }
}

export default withRouter(connect()(ExploreBtn));
